import { render, staticRenderFns } from "./SendMessageTemplate.vue?vue&type=template&id=612281c2&scoped=true"
import script from "./SendMessageTemplate.vue?vue&type=script&lang=js"
export * from "./SendMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./SendMessageTemplate.vue?vue&type=style&index=0&id=612281c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612281c2",
  null
  
)

export default component.exports